<template>
  <div class="p-4">
    <p class="alert alert-danger text-center mb-5">
      {{ $t('pageNotFound') }}
    </p>

    <div class="d-flex">
      <router-link
          :to="{ name: 'home' }"
          class="btn btn-success flex-fill"
      >
        {{ $t('rentLocker') }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {}
</script>
